import {Button, Tabs} from 'antd'
import {course_class_getGrades_Api, course_getGradeByStudentReportByAuth_Api,} from 'apis'
import {getId} from 'apis/model/base'
import {LoginContext} from 'components/LoginContext'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {BiSolidEdit, BiTrash} from 'react-icons/bi'
import {RiSearchEyeLine} from 'react-icons/ri'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {NullAsDefault} from 'views/Shared'
import {renderCourseClassGrade} from 'views/Workspace/Course/functions/renderCourseClassGrade'
import {GradeActionTypes} from '../..'
import getTitle from '../../../../../helpers/getTitle'
import {renderIfElse} from '../../../../Shared'
import EntityList from '../../../EntityList'
import {bindQueryParam} from '../../../functions/routerHelper'
import {HeaderWithIconLine, ListHeaderLineAndDes,} from '../../../Templates/items/ListHeader'
import CourseClassContext from '../../CourseClassContext'
import CouseClassGradeFilter from "../../../../Workspace/Course/components/filters/CouseClassGradeFilter";
import usePaginationHelper, {createPagerKey} from "../../../hooks/usePaginationHelper";
import {DateNameSortBy} from "../../../factory/createEntitySortBy";
import {getType} from "../../../../../apis/model/base";
import EmptyHolder from "../../../../../components/EmptyHolder";
import {LayoutContext} from "../../../../../components/layouts/Default/LayoutContext";
import {BsPersonCircle, BsThreeDots} from "react-icons/bs";
import {useRouteSearchParam} from "../../../../../envs/_current/history";
import {PiUserListFill} from "react-icons/pi";
import {FaIdCard} from "react-icons/fa6";
import {TbClockEdit} from "react-icons/tb";
import {useCourseGrades} from "../../functions/useCourseGrades";
import getLinkToDetail from "../../../../../helpers/getLinkToDetail";
import {useHistory} from "../../../../../modules/navigation/useRouter";


const MyBoard = ({course_class_id}) => {
    const t = useTranslate()
    const login = useContext(LoginContext)
    const history = useHistory()
    const refreshKey = course_class_id

    const ItemInformation = ({ label, value, className }) => (
        <div className={`flex flex-col text-xs mt-1 ${className}`}>
            <span className="font-normal uppercase text-gray-400">{label}</span>
            <span className="font-medium text-gray-800 break-words">{value || '-'}</span>
        </div>
    );


    const renderItem = useCallback((item, index) => {
        const {id, title, subject, subject_title, score_type, score_number, score_text, status, course_class_exam,} = item;

        // Button Logic (kept from old component, adapted slightly to English)
        let buttonText = null;
        let buttonClass = 'bg-gray-100 text-gray-600';

        if (!!score_number || !!score_text) {
            buttonText = 'View Score';
            buttonClass = 'bg-indigo-100 text-indigo-700 font-medium';
        } else if (!!!score_number && !!!score_text && !!course_class_exam?.id) {
            // Đây là nút "Làm bài thi" (Start Exam)
            buttonText = t('start exam');
            buttonClass = 'bg-green-600 text-white font-bold shadow-lg shadow-green-200/50';
        } else if (status === 'upcoming') {
            buttonText = null;
            buttonClass = 'bg-gray-100 text-gray-600 font-medium';
        }

        // New structure based on user query
        return (
            <div key={id}
                 className="p-3 sm:p-4 background rounded-xl shadow-lg hover:shadow-xl transition duration-200 border border-gray-100 flex flex-col gap-3">
                {/* Top Row: Index, Title, and Action Button */}
                <div className="flex justify-between items-start">
                    {/* Index and Title (User's request structure) */}
                    <div className="flex flex-col gap-1 min-w-0 flex-grow pr-4">
                        <div className="space-x-2 text-sm">
                        <span className="font-normal text-gray-500">
                            {/* Dùng 'Assessment' thay cho 'grades' trong context này */}
                            {`${index + 1}. `}
                        </span>
                            <span className="font-bold text-gray-900 truncate">{getTitle(item)}</span>
                        </div>
                    </div>

                    {/* Action Button: Button "Làm bài thi" / "Xem điểm" */}
                    {
                        !!course_class_exam?.id && (
                            <button
                                className={`flex-shrink-0 text-xs px-3 py-2 rounded-lg transition duration-200 ${buttonClass}`}
                                onClick={() => {
                                    history.push(getLinkToDetail(course_class_exam))
                                }}
                            >
                                {buttonText}
                            </button>
                        )
                    }
                </div>


                {/* Details Grid (User's request structure) */}
                <div className="ml-3 grid grid-cols-2 md:grid-cols-4 gap-4 border-t pt-3 border-gray-100">
                    <ItemInformation
                        label={t("subject")}
                        className="col-span-1 md:col-span-2 text-gray-700"
                        value={getTitle(subject)}
                    />
                    {/* Score Information */}
                    <ItemInformation
                        label={t("score")}
                        className="col-span-1 text-indigo-600 font-extrabold"
                        value={renderIfElse(
                            score_type === 'number',
                            // Hiển thị Score Number / Max Score
                            `${score_number === null ? '-' : score_number}`,
                            score_text
                        )}
                    />
                </div>
            </div>
        );
    }, [])

    const renderWrap = useCallback((child, __, count) => {
        return (
            <div className="flex flex-col gap-3 my-2">
                <HeaderWithIconLine
                    icon={<BsPersonCircle size={20} className="text-blue-300"/>}
                    title="my grades"
                    className="text-blue-600 leading-snug"
                    lineColor="border-blue-300"
                    center={true}
                />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2">
                    {child}
                </div>
            </div>
        )
    }, [])

    return login && (
        <EntityList
            key={refreshKey}
            renderEmpty={() => <EmptyHolder title={null} className="col-span-1 md:col-span-2"/>}
            renderItem={renderItem}
            renderWrap={renderWrap}
            refreshKey={refreshKey}
            RenderEntity={React.Fragment}
            query={bindQueryParam({id: course_class_id})}
            apiInfo={course_getGradeByStudentReportByAuth_Api}
        />
    )
}

const CourseClassGradeTab = ({
                                 filter_actions = {
                                     sortBy: 'sort-by',
                                     keyword: 'keyword',
                                     course_id: 'course_id',
                                     subject_id: 'subject-id',
                                 },
                             }) => {
    const t = useTranslate()

    const {isSm} = useContext(LayoutContext)
    const [current, setCurrent] = useState('0')

    const {item} = useContext(CourseClassContext)

    const sortBy = useRouteSearchParam(filter_actions.sortBy)

    const subject_id = useRouteSearchParam(filter_actions.subject_id)

    const can_edit = !!item?.edit

    const course_class_id = getId(item)

    const owner_id = getId(item?.course)

    const owner_type = getType(item?.course)

    const {
        modal,
        refresh_token,
        handleAction = NullAsDefault,
    } = useCourseGrades({course_class: item})

    const refreshKey = useMemo(
        () => [refresh_token, course_class_id].join(''),
        [refresh_token, course_class_id]
    )

    const renderContextMenu = useCallback(
        (item) =>
            can_edit
                ? createContextMenu(
                [
                    // {
                    //     icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                    //     label: 'edit exam',
                    //     key: GradeActionTypes.COURSE_CLASS_EXAM_UPDATE,
                    //     invisible: !!!item?.course_class_exam
                    // },
                    {
                        icon: <RiSearchEyeLine size={14} className="text-green-600"/>,
                        label: 'view grades',
                        key: GradeActionTypes.GRADE_DETAIL,
                    },
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'edit',
                        key: GradeActionTypes.GRADE_UPDATE,
                    },
                    {
                        icon: <TbClockEdit size={14} className="text-color-400"/>,
                        label: 'history',
                        key: GradeActionTypes.GRADE_HISTORY,
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: GradeActionTypes.GRADE_DELETE,
                    },
                ].filter((e) => item && !!!e?.invisible),
                (key) => {
                    handleAction(key, item)
                },
                {
                    icon: (
                        <div
                            style={{width: 22, height: 22, borderRadius: 999}}
                            className="flex flex-center background hover:background-200 text-color-500 hover:text-color-100 cursor-pointer">
                            <BsThreeDots size={12}/>
                        </div>
                    ),
                }
                )
                : undefined,
        [can_edit]
    )

    const [pager_widget] = usePaginationHelper({
        filter_params: {
            owner_id,
            owner_type,
        },
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onFilterChange({
                subject_id,
            })
            onSortChange(sortBy)
        },
        pagerInfo: {
            PaginationMeta: NullAsDefault,
            RenderEntity: React.Fragment,
            apiInfo: course_class_getGrades_Api,
            query: bindQueryParam({id: course_class_id}),
            renderItem: renderCourseClassGrade({
                renderContextMenu,
                handleAction,
            }),
            renderWrap: (child) => (
                <div className="flex flex-col gap-4">
                    {child}
                </div>
            )
        },
        renderSearchBar: NullAsDefault,
        SortByWidget: DateNameSortBy,
        query_params: filter_actions,
        sortHeader: t('list of grades'),
        withKey: createPagerKey(refreshKey),
        AdvancedFilter: CouseClassGradeFilter,
    })

    return (
        <div className="flex flex-col">
            {renderIfElse(
                can_edit,
                <Tabs
                    className="custom-tabs-student"
                    type="card"
                    centered={false}
                    tabBarGutter={8}
                    defaultActiveKey="0"
                    onChange={setCurrent}
                    items={[
                        {
                            key: "0",
                            label: (
                                <span className="flex items-center gap-2">
          <PiUserListFill size={14}/>
          <span className="font-medium leading-tight">
            {t("grade of students")}
          </span>
        </span>
                            ),
                            children: (
                                <div className="w-full flex flex-col flex-1 gap-6 space-y-3">
                                    <div className="flex flex-col gap-1">
                                        <ListHeaderLineAndDes
                                            line={false}
                                            title="grade of students"
                                            description="create grades description"
                                            extra={
                                                <div className="flex flex-1 justify-end gap-2 md:gap-3">
                                                    <Button
                                                        style={{
                                                            padding: isSm ? "0 12px" : "0 18px",
                                                        }}
                                                        className="button-rounded-md no-border flex flex-center bg-primary-50 hover:bg-primary-100 font-medium text-xs md:text-sm text-primary"
                                                        onClick={() => {
                                                            handleAction(GradeActionTypes.VIEW_BY_SUBJECT_FILTER);
                                                        }}>
                                                        {t("results")}
                                                    </Button>
                                                    <Button
                                                        style={{
                                                            padding: isSm ? "0 12px" : "0 18px",
                                                        }}
                                                        type="primary"
                                                        className="button-rounded-md no-border flex flex-center font-medium text-xs md:text-sm"
                                                        onClick={() => {
                                                            handleAction(GradeActionTypes.GRADE_CREATE);
                                                        }}>
                                                        {t("create")}
                                                    </Button>
                                                </div>
                                            }
                                        />
                                        <div className="flex flex-col gap-3">{pager_widget}</div>
                                    </div>
                                </div>
                            ),
                        },
                        {
                            key: "1",
                            label: (
                                <div className="flex items-center gap-2">
                                    <FaIdCard size={14}/>
                                    <span className="font-medium leading-tight">{t("my grades")}</span>
                                </div>
                            ),
                            children: (
                                <div className="w-full flex flex-col flex-1 gap-6 space-y-3">
                                    <MyBoard course_class_id={course_class_id}/>
                                </div>
                            ),
                        },
                    ]}
                />
                ,
                <div className="w-full flex flex-col flex-1 gap-6">
                    <MyBoard course_class_id={course_class_id}/>
                </div>
            )}

            {modal}
        </div>
    )
}

export default CourseClassGradeTab
